export default "__VITE_ASSET__B56dTtgj__"